import React from "react";
import { Box } from "@mui/material";

export interface BaseTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  idPrefix?: string;
}

const BaseTabPanel: React.FC<BaseTabPanelProps> = ({ 
  children, 
  value, 
  index, 
  idPrefix = "tabpanel",
  ...other 
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

export default BaseTabPanel;
